import { render, staticRenderFns } from "./CatalogInner.vue?vue&type=template&id=479afec6&"
import script from "./CatalogInner.vue?vue&type=script&lang=js&"
export * from "./CatalogInner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports